import { render, staticRenderFns } from "./totop.vue?vue&type=template&id=05d22dde&"
import script from "./totop.vue?vue&type=script&lang=js&"
export * from "./totop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports